import * as React from 'react';
import './checkbox.scss';

interface Props {
  checked: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultCheck: boolean;
  text?: string;
  checkBoxname?: string;
  isRed?: boolean;
}

const CheckBox: React.FC<Props> = ({ checked, defaultCheck, text, checkBoxname, isRed }) => {
  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    checked(event);
  };

  return (
    <>
      <label className="checkbox">
        <input
          type="checkbox"
          name={checkBoxname}
          className="checkbox__input"
          checked={defaultCheck}
          onChange={onClick}
        />
        <span className={isRed ? 'checkmark-red' : 'checkmark'}></span>
        {text && <div className="checkbox-text">{text}</div>}
      </label>
    </>
  );
};
export default CheckBox;
